import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import {environment} from '@environment/environment';
import { GetEnvVarService } from "./service/get-env-var.service";

@Injectable({
  providedIn: 'root'  // <-- Add this line
})
export class UserTypeGuard  {

  constructor(private getEnvVarService: GetEnvVarService) {}

  UserRoleID: any;
  internalUser: any = this.getEnvVarService.getAdmin();//environment.Admin;
  externalUser: any = this.getEnvVarService.getInvoice();//environment.Invoice;

  creditManagerAdmin: any = this.getEnvVarService.getRefundApprove();//environment.RefundApprove;

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    //debugger;  
    this.UserRoleID = +sessionStorage.getItem('userRoleId');

    if (sessionStorage.getItem('userType') === 'E') {
      let existance = this.externalUser.indexOf(state.url);
      if (existance >= 0) { 
        return true;
      } else {
         return false;
      }
    } else {

      // let existance = this.internalUser.indexOf(state.url);
      // if (existance >= 0) return true;
      // else return false;

      if (this.UserRoleID === 1 || this.UserRoleID === 2) {
        let existance = this.internalUser.indexOf(state.url);
        if (existance >= 0) {
           return true;
        } else {
           return false;
        }
      } else if (this.UserRoleID === 4) {
        let existance = this.creditManagerAdmin.indexOf(state.url);
        if (existance >= 0) {
           return true;
        } else { 
          return false;
        }
      }

    }

  }
}